<template>
  <AnalysisPage pageName="call" title="電話自動予約受付（IVR）" :disabled="busy || !chart(keepUnit)">
    <AnalysisContent>
      <template #unit>
        <Unit :refetch="fetch" :disabled="busy" />
      </template>
      <template #graph>
        <AnalysisAggregate :busy="busy" :refetch="fetch" />
        <FrameTemplate :busy="busy" :nodata="!chart(keepUnit)">
          <Chart
            type="LineChart"
            :data="chart(keepUnit)"
            :options="options"
            :busy="busy"
            :unit="keepUnit"
            :yearMonths="isMonthly(keepUnit) ? hAxis : []"
          />
          <template #v-axis-unit>件</template>
          <template #year-labels v-if="isMonthly(keepUnit)"><YearLabels :yearMonths="hAxis"/></template>
          <template #h-axis-unit>{{ unitById[keepUnit] }}</template>
        </FrameTemplate>
      </template>
      <template #table>
        <CallTable :busy="busy" />
      </template>
    </AnalysisContent>
  </AnalysisPage>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AnalysisPage from '@/components/templates/AnalysisPage'
import AnalysisContent from '@/components/molecules/AnalysisContent'
import AnalysisAggregate, { Unit } from '@/components/organisms/AnalysisAggregate'
import Chart, { FrameTemplate, YearLabels } from '@/components/molecules/Chart'
import CallTable from './Components/CallTable'

export default {
  name: 'AnalysisCall',
  components: {
    AnalysisAggregate,
    AnalysisPage,
    AnalysisContent,
    Unit,
    Chart,
    FrameTemplate,
    YearLabels,
    CallTable,
  },
  data() {
    return {
      // TODO Storeで管理したい
      keepUnit: 0,
    }
  },
  computed: {
    ...mapState({
      busy: state => state.analysis.call.busy,
      conditions: state => state.analysis.aggregate.conditions,
      unitById: state => state.analysis.unit.shortById,
    }),
    ...mapGetters({
      query: 'analysis/aggregate/query',
      chart: 'analysis/call/chart',
      hAxis: 'analysis/call/hAxis',
      isMonthly: 'analysis/unit/isMonthly',
      colors: 'analysis/call/colors',
    }),
    options() {
      return {
        colors: this.colors,
      }
    },
  },
  watch: {
    $route() {
      this.fetch()
    },
    busy(newValue) {
      if (!newValue) {
        this.keepUnit = this.conditions.unit
      }
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      const { dispatch } = this.$store
      const { unit, startTerm, endTerm } = this.query
      await dispatch('analysis/call/get', {
        unit,
        startTerm,
        endTerm,
      })
    },
  },
}
</script>

<style scoped lang="postcss">
/* style */
</style>
